import { render, staticRenderFns } from "./BudgetAccountTransactionsDialog.vue?vue&type=template&id=2c4f6a80&scoped=true"
import script from "./BudgetAccountTransactionsDialog.vue?vue&type=script&lang=js"
export * from "./BudgetAccountTransactionsDialog.vue?vue&type=script&lang=js"
import style0 from "./BudgetAccountTransactionsDialog.vue?vue&type=style&index=0&id=2c4f6a80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4f6a80",
  null
  
)

export default component.exports